



import { Component, namespace, Vue } from 'nuxt-property-decorator'
import { IMeta } from '~/assets/interfaces/meta'

const pageStore = namespace('page')

@Component
export default class ComponentTypographyH1 extends Vue {
  @pageStore.State('meta') private meta!: IMeta | null
}
